import { motion } from "framer-motion";
import { LineReveal } from "./Reveal";

export default function PageHero({ eyebrow, titleLines, description, testid }) {
  return (
    <section className="relative pt-40 pb-16 sm:pb-24 px-4 sm:px-6 lg:px-8 overflow-hidden" data-testid={testid}>
      <div
        className="absolute -top-40 left-1/2 -translate-x-1/2 w-[720px] h-[420px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(ellipse, rgba(212,175,55,0.12) 0%, transparent 65%)" }}
      />
      <div className="max-w-5xl mx-auto relative">
        <motion.p
          className="caption-gold mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          {eyebrow}
        </motion.p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-[1.12]">
          {titleLines.map((line, i) => (
            <LineReveal key={i} delay={0.12 + i * 0.14}>
              {line}
            </LineReveal>
          ))}
        </h1>
        {description && (
          <motion.p
            className="mt-7 max-w-2xl text-base sm:text-lg text-[#A1A1AA] leading-relaxed"
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.5 }}
          >
            {description}
          </motion.p>
        )}
      </div>
    </section>
  );
}
